<template>
    <div class="d-flex">
        <span class="icon icon-charger-availability-off charger-icon-size text-gray4" aria-hidden="true" />
        <div class="charger-infos">
            <div class="d-flex align-items-center">
                <div
                    class="icon icon-charger-availability charger-icon-size position-relative right-15 text-gray4"
                    :aria-hidden="true"
                >
                    <p class="visually-hidden" v-html="chargerInfos.iconMessageAccessibility" />
                </div>
                <div class="py-0 fw-bold text">
                    <div v-html="chargerInfos.powerMin + '-' + chargerInfos.powerMax" />
                    <div>W</div>
                    <div v-if="chargerInfos.compatiblePDC">
                        USB PD
                    </div>
                </div>
                <a
                    href="#"
                    data-bs-toggle="modal"
                    :data-bs-target="'#modal-charger-compatible'"
                    :aria-label="chargerInfos.iconMessageAccessibility"
                >
                    <strong class="position-relative right-15" v-html="chargerInfos.compatibleMessage" />
                </a>
            </div>
        </div>
        <ob1-popin-modal-visual
            id="modal-charger-compatible"
            aria-labelledby="modal-label-charger-compatible"
            additional-classes="d-webview-none d-md-block"
        >
            <template #visual>
                <div :class="['ob1-modal-img', isSoshShop ? 'bg-primary3' : 'bg-black']">
                    <div class="charger-popin-infos">
                        <div
                            class="icon icon-charger-availability charger-popin-icon-size text-white"
                            aria-hidden="true"
                        />
                        <div :class="['py-0 fw-bold text', isSoshShop ? 'text-white' : 'text-dark']">
                            <div v-html="chargerInfos.powerMin + '-' + chargerInfos.powerMax" />
                            <div>W</div>
                            <div v-if="chargerInfos.compatiblePDC">
                                USB PD
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template #content>
                <p id="modal-charger-compatible" class="h4" v-html="chargerInfos.popinTitle" />
                <p v-html="chargerInfos.popinText" />
            </template>
        </ob1-popin-modal-visual>
    </div>
</template>

<script>
export default {
    name: "ChargerInfos",
    props: {
        chargerInfos: {
            type: Object,
            required: true
        },
        isSoshShop: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.right-15 {
    right: px-to-rem(15);
}

.charger-icon-size {
    font-size: px-to-rem(81);
}

.charger-infos {
    position: relative;
    width: px-to-rem(234);
    @media (min-width: 736px) {
        width: px-to-rem(170);
    }
}

.charger-infos .text {
    position: absolute;
    right: px-to-rem(173);
    top: px-to-rem(28);
    width: 4.4375rem;
    text-align: center;
    line-height: 14px;
    font-size: px-to-rem(12);
    @media (min-width: 736px) {
        right: px-to-rem(109);
    }
}

.charger-popin-infos {
    position: relative;
    width: px-to-rem(170);
    height: px-to-rem(180);
    top: 16%;
    left: 34%;
    @media (min-width: 736px) {
        top: 22%;
        left: 0;
        text-align: center;
    }
}

.charger-popin-icon-size {
    font-size: px-to-rem(110);
    @media (min-width: 736px) {
        font-size: px-to-rem(130);
    }
}

.charger-popin-infos .text {
    position: absolute;
    text-align: center;
    line-height: 14px;
    font-size: px-to-rem(12);
    right: 51%;
    top: 25%;
    width: px-to-rem(55);
    @media (min-width: 736px) {
        right: 30%;
        top: 30%;
        width: px-to-rem(68);
    }
}
</style>
